export default __webpack_public_path__ + "static/alfred_find_file_enter-abb677a8cc0305cc9fcbe76d1c32e89f.png";